<template lang="pug">
  div(ref="container" :style="`width:100%; height:100%; min-height:${height}`")
    v-chart(:options="innerOptions" :height="height" :autoresize="true")
</template>

<script>
import $ from "jquery";
import ECharts from "./echart";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";

import "echarts-gl";

export default {
  name: "b-chart-scatter",
  props: ["data", "columns", "labels", "options", "colors"],
  data() {
    return {};
  },
  computed: {
    height() {
      return `${this.options.height || "650px"}`;
    },
    serie_type() {
      return "scatter";
    },
    accepts_cero_as_value() {
      return ["bar-100", "bar-stacked"].indexOf(this.$props.options.type) > -1;
    },
    processed_data() {
      let series = [];

      this.$props.data.forEach(row => {
        series.push(
          this.format(
            {
              data: [row.value],
              name: row.description,
              label: row.label
            },
            this.accepts_cero_as_value
          )
        );
      });

      return {
        series
      };
    },
    innerOptions() {
      if (
        !this.processed_data.series ||
        this.processed_data.series.length === 0
      )
        return {};

      return {
        title: {
          text: this.$props.options.showTitle
            ? this.$props.options.title
            : null,
          textStyle: {
            color: "#346899",
            fontSize: "18"
          },
          top: '7%',
          left: 'center'
        },
        grid: {
          top: this.$root.isMobile() ? "30%" : "25%",
          left: "5%",
          right: "3%",
          bottom: "65",
          containLabel: true
        },
        backgroundColor: this.$props.options.backgroundColor,
        footer: this.$props.options.footer,
        color: this.colors || this.$props.options.colors,
        legend: {
          orient: "horizontal",
          right: 10,
          top: 40,
          bottom: 20
        },
        tooltip: {
          trigger: "item",
          formatter: params => {
            console.log(params);
            let label = this.processed_data.series[params.seriesIndex].label;
            let value = params[params.$vars[2]]
              .map((value, i) => {
                return `${this.columns[i]}: ${value.toLocaleString("es-PY")}`;
              })
              .join("<br>");
            return `<strong>${label}</strong><br>${value}`;
          }
        },
        xAxis: {
          type: "category",
          name: this.columns[1],
          axisLabel: {
            formatter: value => value.toLocaleString("es-PY")
          },
          nameLocation: "middle",
          nameGap: 30
        },
        yAxis: {
          name: this.columns[0],
          nameGap: 30,
          axisLabel: {
            formatter: value => value.toLocaleString("es-PY")
          },
          nameLocation: "middle",
          nameRotate: 90,
          axisLine: {
            show: false
          }
        },
        series: this.processed_data.series,
        animationDuration: 2000
      };
    }
  },
  methods: {
    format(serie, stackable) {
      serie.type = this.serie_type;
      if (stackable && this.$props.options.type !== "area-basic")
        serie.stack = "stack";
      if (["area-stack", "area-basic"].indexOf(this.$props.options.type) > -1)
        serie.areaStyle = {};
      return serie;
    }
  },
  components: {
    "v-chart": ECharts
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// scatter.vue